module.exports = __webpack_public_path__ + "img/goden_bg.df7a9db9.png";